<template>
    <form method="post" action="" v-on:submit="submitForm">
        <div class="form-group">
            <label>User ID: *</label><br />
            <input type="text" name="user_id" v-model="finalData.userId" />
        </div>
        <div class="form-group">
            <button type="submit">{{ submitText || 'Submit' }}</button>
        </div>
    </form>
</template>

<script>
export default {
    name: 'PolicyExceptionForm',
    props: ['formData', 'submitText'],
    emits: ['formSubmitted'],
    data: function() {
        return {
            finalData: this.formData ? JSON.parse(JSON.stringify(this.formData)) : {},
        }
    },
    methods: {
        submitForm(e) {
            e.preventDefault()
            this.$emit('formSubmitted', this.finalData)
        }
    }
}
</script>

<style lang="scss" scoped>
.existing-file {
    display: block;
    width: fit-content;
    padding: 2px;
    margin-bottom: 2px;
    border: 1px solid #aaa;
}
</style>
